/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as TextLinkDefault } from './text-link-default.story';
export { default as TextLinkExternal } from './text-link-external.story';
export { default as TextLinkExternalUnderline } from './text-link-external-underline.story';
export { default as TextLinkInternalIcon } from './text-link-internal-icon.story';
export { default as TextLinkInternalUnderline } from './text-link-internal-underline.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import TextLinkDefaultSourceRaw from './text-link-default.story?raw';
import TextLinkExternalSourceRaw from './text-link-external.story?raw';
import TextLinkExternalUnderlineSourceRaw from './text-link-external-underline.story?raw';
import TextLinkInternalIconSourceRaw from './text-link-internal-icon.story?raw';
import TextLinkInternalUnderlineSourceRaw from './text-link-internal-underline.story?raw';

export const TextLinkDefaultSource = removeLicenseHeader(
  TextLinkDefaultSourceRaw,
);
export const TextLinkExternalSource = removeLicenseHeader(
  TextLinkExternalSourceRaw,
);
export const TextLinkExternalUnderlineSource = removeLicenseHeader(
  TextLinkExternalUnderlineSourceRaw,
);
export const TextLinkInternalIconSource = removeLicenseHeader(
  TextLinkInternalIconSourceRaw,
);
export const TextLinkInternalUnderlineSource = removeLicenseHeader(
  TextLinkInternalUnderlineSourceRaw,
);
